/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const WorkbenchApiRequestsResponse = zod
	.array(
		zod
			.object({
				duration_ms: zod.number().describe('Request duration in ms'),
				event_id: zod.string().describe('Event ID'),
				method: zod.string().describe('HTTP method'),
				occurred_at: zod.iso.datetime({ offset: true }).describe('When the request occurred'),
				route_pattern: zod.string().describe('Route pattern'),
				status_class: zod.number().describe('HTTP status class (200, 400, 500)'),
				status_code: zod.number().describe('HTTP status code')
			})
			.describe('API request log row')
	)
	.describe('List of API request log rows');

export type WorkbenchApiRequestsResponse = zod.input<typeof WorkbenchApiRequestsResponse>;
export type WorkbenchApiRequestsResponseOutput = zod.output<typeof WorkbenchApiRequestsResponse>;
